/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ErpAttributes } from './ErpAttributes';
import {
    ErpAttributesFromJSON,
    ErpAttributesFromJSONTyped,
    ErpAttributesToJSON,
} from './ErpAttributes';
import type { ErpWaypoint } from './ErpWaypoint';
import {
    ErpWaypointFromJSON,
    ErpWaypointFromJSONTyped,
    ErpWaypointToJSON,
} from './ErpWaypoint';
import type { Warp } from './Warp';
import {
    WarpFromJSON,
    WarpFromJSONTyped,
    WarpToJSON,
} from './Warp';

/**
 * The erp object is used for storing information relevant to the ERP system. It can contain any kind of valid json information. Only the shown properties are recognized by the AIS system.
 * @export
 * @interface ERP
 */
export interface ERP {
    /**
     * The warp array is used for describing upcoming warps. The first is arrival at the port and any subsequent are movements internally at the port. Notice the eta of the first warp is used by the AIS system as indication of the expected arrival time at the port.
     * @type {Array<Warp>}
     * @memberof ERP
     */
    warp?: Array<Warp>;
    /**
     * The attributes may be used as a key:value set that can be displayed and edited in aisWeb. The information is entirely up the port and integrator.
     * @type {Array<ErpAttributes>}
     * @memberof ERP
     */
    attributes?: Array<ErpAttributes>;
    /**
     * Defining one or more waypoints, the portserver will interpret the defined points as "sub destinations", which means that the colculated route will pass through the points toward the final destination. When waypoints are defined the track result will contain an array of waypoint ETAs that will map to the defined list of waypoints.
     * @type {Array<ErpWaypoint>}
     * @memberof ERP
     */
    waypoints?: Array<ErpWaypoint>;
}

/**
 * Check if a given object implements the ERP interface.
 */
export function instanceOfERP(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ERPFromJSON(json: any): ERP {
    return ERPFromJSONTyped(json, false);
}

export function ERPFromJSONTyped(json: any, ignoreDiscriminator: boolean): ERP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'warp': !exists(json, 'warp') ? undefined : ((json['warp'] as Array<any>).map(WarpFromJSON)),
        'attributes': !exists(json, 'attributes') ? undefined : ((json['attributes'] as Array<any>).map(ErpAttributesFromJSON)),
        'waypoints': !exists(json, 'waypoints') ? undefined : ((json['waypoints'] as Array<any>).map(ErpWaypointFromJSON)),
    };
}

export function ERPToJSON(value?: ERP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'warp': value.warp === undefined ? undefined : ((value.warp as Array<any>).map(WarpToJSON)),
        'attributes': value.attributes === undefined ? undefined : ((value.attributes as Array<any>).map(ErpAttributesToJSON)),
        'waypoints': value.waypoints === undefined ? undefined : ((value.waypoints as Array<any>).map(ErpWaypointToJSON)),
    };
}

